import { Injectable } from '@angular/core';
import { driver } from 'driver.js';
import { ConnectionService } from './connection.service';

@Injectable({ providedIn: 'root' })
export class TourService {

  constructor(private connection: ConnectionService) {}

  private markDone(key: string) {
    localStorage.setItem(key, 'done');
    const all = ['tour_home', 'tour_eventi', 'tour_evento', 'tour_profilo'];
    const done = all.filter(k => localStorage.getItem(k) === 'done');
    this.connection.put('@auth/preferences', { tours_completed: done }, () => {}, () => {});
  }

  private run(key: string, steps: any[]) {
    // I tour non partono più in automatico: girano solo se richiesti
    // esplicitamente da Impostazioni → Rivedi (flag `tour_request`).
    if (localStorage.getItem('tour_request') !== key) return;
    localStorage.removeItem('tour_request');

    const d = driver({
      showProgress: true,
      nextBtnText: 'Avanti →',
      prevBtnText: '← Indietro',
      doneBtnText: 'Capito!',
      onDestroyStarted: () => {
        this.markDone(key);
        d.destroy();
      },
      steps,
    });

    setTimeout(() => d.drive(), 600);
  }

  home() {
    this.run('tour_home', [
      {
        element: '#tour-eventi',
        popover: {
          title: 'I tuoi eventi',
          description: 'Qui trovi tutti gli eventi: lista, ricerca e accesso rapido alla scheda di ogni cliente.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-crea-evento',
        popover: {
          title: 'Crea un evento',
          description: 'Da qui parti: inserisci i dati del cliente e dell\'evento in pochi minuti.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-notifiche',
        popover: {
          title: 'Notifiche',
          description: 'Ti avvisiamo quando un cliente firma il contratto o un collega ti invita a collaborare.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-profilo',
        popover: {
          title: 'Il tuo profilo',
          description: 'Qui configuri i tuoi dati personali, la categoria professionale e il team.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-impostazioni',
        popover: {
          title: 'Impostazioni',
          description: 'Lingua, notifiche e questo tour — tutto gestibile da qui.',
          side: 'bottom',
        },
      },
    ]);
  }

  profilo() {
    this.run('tour_profilo', [
      {
        element: '#tour-tab-profilo',
        popover: {
          title: 'Profilo',
          description: 'I tuoi dati personali, la categoria professionale e l\'avatar.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-tab-team',
        popover: {
          title: 'Team',
          description: 'Il tuo team fisso: nome, ruolo e disponibilità. Li assegni rapidamente agli eventi.',
          side: 'bottom',
        },
      },
    ]);
  }

  eventi() {
    this.run('tour_eventi', [
      {
        element: '#tour-eventi-list',
        popover: {
          title: 'Lista eventi',
          description: 'Tutti i tuoi eventi in ordine di data. Clicca su uno per aprire la scheda completa.',
          side: 'top',
        },
      },
      {
        element: '#tour-eventi-new',
        popover: {
          title: 'Nuovo evento',
          description: 'Crea un nuovo evento: inserisci cliente, data, luogo e servizi.',
          side: 'bottom',
        },
      },
    ]);
  }

  evento() {
    this.run('tour_evento', [
      {
        element: '#tour-tab-evento',
        popover: {
          title: 'Evento',
          description: 'Data, orario, location e note dell\'evento, i dati della cliente e la prova o il sopralluogo prima del giorno principale.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-tab-servizi',
        popover: {
          title: 'Servizi',
          description: 'I servizi scelti dalla cliente con i prezzi, la trasferta e lo sconto.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-tab-contratto',
        popover: {
          title: 'Contratto',
          description: 'Generazione e firma del contratto, più i documenti dell\'evento.',
          side: 'bottom',
        },
      },
      {
        element: '#tour-tab-collaboratori',
        popover: {
          title: 'Collaboratori',
          description: 'Assegna colleghi all\'evento e gestisci il team di lavoro.',
          side: 'bottom',
        },
      },
    ]);
  }
}
